module.exports = __webpack_public_path__ + "static/media/release_notes.3153ec2b.png";